import { composeReferralCouponRouteTemplate } from '@/lib/coupon/gen-code'
import { DEFAULT_REFERRAL_AMOUNT_COUPON } from '@/providers/coupon/ReferralCouponProvider'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/referral-coupon/amount')(
  composeReferralCouponRouteTemplate(DEFAULT_REFERRAL_AMOUNT_COUPON),
)
